import Vue from "vue";
import App from "./App";
import store from "./store/store";
import router from "./router";
import VueResource from "vue-resource";
import VueJwtDecode from "vue-jwt-decode";
import swal from "sweetalert";
import { firestorePlugin } from "vuefire";
import { TablePlugin } from "bootstrap-vue";
import { FormDatepickerPlugin } from "bootstrap-vue";
import VueI18n from "vue-i18n";

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import VueQuillEditor from "vue-quill-editor";
Vue.use(VueQuillEditor);
Vue.use(VueI18n);
Vue.use(FormDatepickerPlugin);
Vue.use(TablePlugin);
Vue.config.productionTip = false;
Vue.use(VueJwtDecode);
Vue.use(VueResource);
Vue.use(firestorePlugin);

if (window.location.hostname == "localhost") {
  Vue.http.options.root = "https://capacitacioncontratistas.com/api/public/pri";
  Vue.http.options.url = "https://capacitacioncontratistas.com/api/public/pri";
  //Vue.http.options.root = 'https://universidadqualtia.com/api/public/pri';
  //Vue.http.options.url = 'https://universidadqualtia.com/api/public/pri';
} else {
  if (
    window.location.hostname == "www.lmsedk.com" ||
    window.location.hostname == "lmsedk.com"
  ) {
    Vue.http.options.root = "https://lmsedk.com/DEMO/api/public/pri";
    Vue.http.options.url = "https://lmsedk.com/DEMO/api/public/pri";
  } else {
    Vue.http.options.url =
      "https://" + window.location.hostname + "/api/public/pri";
    Vue.http.options.root =
      "https://" + window.location.hostname + "/api/public/pri";
  }
}

const en = require("./i18n/english.json");
const es = require("./i18n/espanol.json");
const pt = require("./i18n/portugues.json");

const messages = {
  en,
  es,
  pt
};

const i18n = new VueI18n({
  locale: "es",
  messages
});
Vue.i18n = i18n

/*
if (!localStorage.getItem('lmsedk_cliente_api') || localStorage.getItem('lmsedk_cliente_api')=='undefined' || localStorage.getItem('lmsedk_cliente_api')==undefined) {
  localStorage.lmsedk_cliente_api="https://www.lmsedk.com/clientes/api/public/pri";
}
Vue.http.options.root=localStorage.lmsedk_cliente_api;
Vue.http.options.url=localStorage.lmsedk_cliente_api;
*/

Vue.http.options.url_admin = "https://www.lmsedk.com/lms-admin/api/public/pri";

if (
  !localStorage.getItem("apiKey_lms") ||
  localStorage.getItem("apiKey_lms") == "undefined" ||
  localStorage.getItem("apiKey_lms") == undefined
) {
  localStorage.apiKey_lms = JSON.stringify(
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsbXMiLCJkYXRhIjp7ImN2ZV9lbXBsZWFkbyI6IkdlbmVyaWNvIn0sImlhdCI6MTU4NTMyNjIxMCwiZXhwIjoxOTAwODU5MDEwfQ.f10H0hIQDQqfRx0MpCklJZHhru2pvU1jS0VyLk3w0w0"
  );
}

Vue.http.interceptors.push((request, next) => {
  if (
    !localStorage.getItem("apiKey_lms") ||
    localStorage.getItem("apiKey_lms") == "undefined" ||
    localStorage.getItem("apiKey_lms") == undefined
  ) {
    localStorage.apiKey_lms = JSON.stringify(
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsbXMiLCJkYXRhIjp7ImN2ZV9lbXBsZWFkbyI6IkdlbmVyaWNvIn0sImlhdCI6MTU4NTMyNjIxMCwiZXhwIjoxOTAwODU5MDEwfQ.f10H0hIQDQqfRx0MpCklJZHhru2pvU1jS0VyLk3w0w0"
    );
  }
  request.headers.set(
    "Authorization",
    "Bearer " + JSON.parse(localStorage.apiKey_lms)
  );
  request.headers.set("Accept", "application/json");
  next(res => {
    if (res.status == 401) {
      setTimeout(function () {
        swal.close();
        swal({
          title: "Sesión Caducada",
          text:
            "Otra persona está utilizando este usuario o han pasado mas de 10 minutos sin interacción",
          icon: "error",
          button: "Aceptar"
        }).then(value => {
          $("#Cerrar_Sesion_LMS").click();
        });
      }, 1000);
    } else if (res.status == 409) {
      setTimeout(function () {
        swal.close();
        $("#modalConfirmarCambioPlan").modal("show")
        $("#Cerrar_Sesion_LMS").click();
      }, 1000);
    }
  });
});

$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader(
      "Authorization",
      "Bearer " + JSON.parse(localStorage.apiKey_lms)
    );
  }
});

Date.prototype.toDateInputValue = function () {
  var local = new Date(this);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
};

Date.prototype.toDateInputValue_3Mes_Atras = function () {
  var local = new Date(this);
  local.setMonth(local.getMonth() - 3);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
};

Date.prototype.toDateInputValue_Mes_Anterior = function () {
  var local = new Date(this);
  local.setMonth(local.getMonth() - 1);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
};

Date.prototype.toDateInputValue_Mes_Siguiente = function () {
  var local = new Date(this);
  local.setMonth(local.getMonth() + 1);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0, 10);
};


router.beforeEach((to, from, next) => {


  if (to.matched.some(record => record.meta.requiresAuth)) {

    $(document).ready(function () {
      if (VueJwtDecode.decode(JSON.parse(localStorage.apiKey_lms)).data.cve_empleado != 'Generico') {
        $(".sidebar-item").each(function (i, element) {
          $(element).removeClass("active_opcion");
        });
        $("#" + to.meta.title).addClass("active_opcion");
        next();
      } else {
        next({ name: "Login" });
      }
    });

  } else {
    next();
  }
});

window.HttpClient = function () {
  this.get = function (aUrl, aCallback) {
    var anHttpRequest = new XMLHttpRequest();
    anHttpRequest.onreadystatechange = function () {
      if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
        aCallback(anHttpRequest.responseText);
    };

    anHttpRequest.open("GET", aUrl, true);
    anHttpRequest.send(null);
  };
};
Vue.config.debug = false;
Vue.config.silent = true;

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  i18n,
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js